import axios from '../utils/axios';

export default function upsertCourseMapping(adminId, data) {
    return (
        axios.post('/admin/' + adminId +'/courses/course-mapping',  data )
    )
}